import axios from 'axios';

// Create axios instance with proper base URL
const instance = axios.create({
  baseURL: '/api/v1',  // Use relative URL - nginx will proxy to backend
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests if it exists
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default instance;
